/* loaded by smart-asset */
export default require("./notification_important-24px~DqKxghsD.svg")